export default __webpack_public_path__ + "static/media/cert5.0a74b44a.jpg";